import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export abstract class CfgService<T> {
  private httpClient: HttpClient;
  protected data: T;
  protected exclude: boolean;
  public initialized: Promise<void>;
  private initializator: { run: () => void };

   constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
    this.data = null;

    this.initialized = new Promise<void>((resolve, reject) => {
      this.initializator = {
        run: () => {
          if (this.exclude) {
            let cfgFile = this.getCfgFile();
            this.httpClient.get<T>(cfgFile).toPromise()
              .then(response => {
                this.data = response;
                resolve();
              })
              .catch(error => {
                this.data = null;
                reject(error);
              });
          } else {
            this.loadDataUrl();
            resolve();
          }
        }
      }
    });
  }

  public initialize(): Promise<void> {
    this.initializator.run();
    return this.initialized;
  }

  protected loadDataUrl() { }

  protected abstract getCfgFile(): string;

  public getCfg(): T {
    return this.data;
  }

  /**
   * Reemplaza las variables del json
   * @param data Datos del json
   * @param vars Variables que van hacer reemplazados
   */
  public replacePlaceholders(data: T, vars: { [key: string]: string }) {
    const jsonString = JSON.stringify(data);
    const newData: any = jsonString.replace(/%\{(.*?)\}/g, (_, key) => {
      return vars[key] || `%{${key}}`;
    });

    this.data = JSON.parse(newData);
  }
}
